import React from "react";
import { BadgeCheck } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function VerifiedBadge({ size = 14, withText = false }) {
  const { t } = useI18n();
  return (
    <span className="inline-flex items-center gap-1 text-[#0EA5E9]" title={t("seller.verified")} data-testid="verified-badge">
      <BadgeCheck style={{ width: size, height: size }} className="fill-[#0EA5E9] text-white" />
      {withText && <span className="text-xs font-semibold">{t("seller.verified")}</span>}
    </span>
  );
}
